import React, { useEffect, useState, useContext } from 'react';
import {
  Container,
  Typography,
  Stack,
  Button,
  IconButton,
  Alert,
  Paper,
  Box
} from '@mui/material';
import {Edit, Delete, Add  } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import chatApi from '../../api/chatApi';
import { AuthContext } from '../../auth/AuthContext';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';
import { formatDate } from '../../utils/dateFormatter';
const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};
export default function ChatListPageDesktop() {
  const { user } = useContext(AuthContext);
  const [rooms, setRooms] = useState([]);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRooms();
  }, []);

  const fetchRooms = async () => {
    try {
      const res = await chatApi.listRooms();
      setRooms(res.data);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  const openDeleteDialog = (id) => {
    setSelectedId(id);
    setOpenDeleteModal(true);
  };

    const closeDeleteDialog = () => {
      setSelectedId(null);
      setOpenDeleteModal(false);
    };

    const confirmDelete = async () => {
      setError(null);

      try {
        setLoading(true);
        await chatApi.deleteRoom(selectedId);
        setOpenDeleteModal(false);
        setLoading(false);
        fetchRooms();
      } catch (err) {
        setError(extractErrorMessage(err));
      } finally {
        setLoading(false);
        setSelectedId(null);
        setOpenDeleteModal(false);
      }
    };

  return (
    <Container>
      <BackButtonDesktop />
      {error && <Alert severity="error">{String(error)}</Alert>}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" sx={{ mb: 2 }}>
          Chat
        </Typography>

        <ProtectedAction user={user} roles={['ADMIN']}>
          <Button
            variant="contained"
            onClick={() => navigate('/chatroomcreate')}
          >
            Nuova stanza
          </Button>
        </ProtectedAction>
      </Stack>

      <Stack spacing={2}>
        {rooms.map(room => (
        <Stack spacing={2}>
          <Paper
            key={room.id}
            sx={{
              p: 2,
              cursor: 'pointer'
            }}
            onClick={() => navigate(`/chatroom/${room.id}`)}
          >
            <Typography variant="h6">
              {room.name}
            </Typography>

            <Typography variant="body2">
              Tipo: {room.type}
            </Typography>

            <Typography variant="caption">
              Creata il: {formatDate(room.createdAt)}
            </Typography>
          </Paper>
          <Typography variant="caption">
                  <ProtectedAction user={user} roles={['ADMIN']}>
                      <IconButton color="error" size="small" onClick={() => openDeleteDialog(room.id)}><Delete /></IconButton>
                  </ProtectedAction>
           </Typography>
           </Stack>
        ))}

      </Stack>
            <ConfirmDeleteModal
              open={openDeleteModal}
              onCancel={closeDeleteDialog}
              onConfirm={confirmDelete}
              message="Sei sicuro di voler eliminare questa stanza?"
            />
    </Container>
  );
}